import React from 'react';

/*
 * Shared pieces for threat actor pages. Every fact on a profile says where it came from,
 * because a customer acting on "this group targets your sector" needs to know who says so.
 */

export const SOURCE_LABEL = {
  mitre: 'ATT&CK',
  derived: 'From ATT&CK text',
  analyst: 'Analyst',
  insights: 'Our reporting',
};
const SOURCE_TITLE = {
  mitre: 'Published by MITRE ATT&CK',
  derived: 'Read from the ATT&CK description by IntelliSecure; not yet confirmed by an analyst',
  analyst: 'Set or confirmed by an IntelliSecure analyst',
  insights: 'Seen in stories IntelliSecure attributed to this actor, approved by an analyst',
};

export function SourceTag({ source }) {
  if (!source) return null;
  return <span className={`ac-src ac-src--${source}`} title={SOURCE_TITLE[source]}>{SOURCE_LABEL[source] || source}</span>;
}

/** Tags for list entries. ATT&CK is the default source and goes unmarked unless asked for. */
export function SourceTags({ sources = [], showMitre = false }) {
  const shown = showMitre ? sources : sources.filter((s) => s !== 'mitre');
  if (!shown.length) return null;
  return <span className="ac-srcs">{shown.map((s) => <SourceTag key={s} source={s} />)}</span>;
}

export function TypeBadge({ type, label }) {
  return <span className={`ac-type ac-type--${type || 'unknown'}`}>{label || 'Unclassified'}</span>;
}

export const plural = (n, w, many = `${w}s`) => `${n.toLocaleString('en-US')} ${n === 1 ? w : many}`;

export function defang(v) {
  return String(v)
    .replace(/^http/i, 'hxxp')
    .replace(/\.(?=[^.]*$)/, '[.]');
}
